import { Typography } from '@mui/material';
import type { FC, PropsWithChildren, ReactNode } from 'react';

import type { CallDetailsParticipantMetadataProps } from 'features/call/call-details/components';
import { CallDetailsParticipantMetadata } from 'features/call/call-details/components';
import { Separator } from 'features/call/call-details/styles';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export interface CallDetailsParticipantProps extends PropsWithChildren<CallDetailsParticipantMetadataProps> {
  title: string;
  icon: ReactNode;
  testId?: string;
  extensionInput?: ReactNode;
}

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ParticipantWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing(8)};
  margin-bottom: ${theme.spacing(8)};
`;

const DetailsColumn = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: ${theme.spacing(4)};
`;

export const CallDetailsParticipant: FC<CallDetailsParticipantProps> = ({
  name,
  phoneNumber,
  location,
  title,
  children,
  icon,
  testId,
  extensionInput,
  isWavelloRegistered = false,
}) => {
  return (
    <Container data-testid={testId}>
      <Typography variant='label' color={theme.palette.grey[300]} mb={4}>
        {title}
      </Typography>
      <ParticipantWrapper>
        {icon}
        <DetailsColumn>
          <CallDetailsParticipantMetadata
            name={name}
            location={location}
            phoneNumber={phoneNumber}
            isWavelloRegistered={isWavelloRegistered}
          />
          {extensionInput}
        </DetailsColumn>
      </ParticipantWrapper>
      {extensionInput ? <Separator /> : null}
      {children}
    </Container>
  );
};
